module.exports = __webpack_public_path__ + "img/首页-企业_02.b6d4b583.jpg";